import {
  DotLottieWorkerReact,
  DotLottieWorkerReactProps,
  DotLottieWorker,
} from '@lottiefiles/dotlottie-react'
import { FC, useEffect, useState } from 'react'

type Props = DotLottieWorkerReactProps & {
  frame: number
}

export const LottieFromFrame: FC<Props> = ({
  frame,
  data,
  width,
  height,
  className,
  dotLottieRefCallback,
  ...props
}) => {
  const [lottie, setLottie] = useState<DotLottieWorker | null>(null)
  useEffect(() => {
    if (!lottie) return

    const play = () => {
      if (!lottie) return

      lottie.setFrame(frame)
      lottie.setLoop(true)
      lottie.play()
    }

    lottie.addEventListener('ready', play)
    return () => {
      lottie.removeEventListener('ready', play)
    }
  }, [lottie])

  const lottieCallback = (lottie: DotLottieWorker) => {
    setLottie(lottie)
    if (typeof dotLottieRefCallback === 'function') {
      dotLottieRefCallback(lottie)
    }
  }

  return (
    <DotLottieWorkerReact
      data={data}
      width={width}
      height={height}
      className={className}
      dotLottieRefCallback={lottieCallback}
      {...props}
    />
  )
}
